import styled from "styled-components";

export const NGNWithdrawalStyle = styled.div`
  width: ${(props) => props.width || "100%"};
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 992px) {
    width: 100%;
  }

  .typeOfCryptoBanner {
    // background: ${(props) => props.cryptoBannerBg || "#006F95"};
    // color: #fff;

    background: ${(props) => props.theme.colors.bg || "#112E46"};
    color: ${(props) => props.theme.colors.color || "#FFFFFF"};
  }

  .Success-banner {
    // background: ${(props) => props.successBannerBg || "#006F95"};
    // color: #fff;

    background: ${(props) => props.theme.colors.bg || "#112E46"};
    color: ${(props) => props.theme.colors.color || "#FFFFFF"};

    height: 405px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .success-img-div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .success-img-div img {
    width: 93px;
    height: 93px;
    display: block;
  }

  .recieve-img-div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .recieve-img-div img {
    width: 93px;
    height: 93px;
    display: block;
  }

  .backTo {
    transform: rotateY(-180deg);
  }
`;

export const NGNWithdrawalOtpModalStyle = styled.div`
.border-bottom {
    border-bottom: 1px solid #eff0f5;
  }
`;


